import useFilters from "./useFilters";

function useFilterCampaigns(campaigns, orgId) {
    return useFilters(campaigns, [campaign => !orgId || campaign.orgId === orgId], [campaigns, orgId])
}

export default useFilterCampaigns;